module.exports = __webpack_public_path__ + "img/s_airport_2.95a908ac.jpg";